/**
 * Commerce7 Collection Filter - clear filter handle
 */
import { renderVivinoScore } from "./c7-util";

export default function C7AddToCart() {


    this.init = () => {
        c7.addAction("c7_add_to_cart_rendered", (content) => {
            // Do something after collection rendered.
            formatPrice()
        });
        // const shop = document.getElementById("shop-filter")
        // if (shop) {
        //     renderedCollection();
        //     registerEventHandlers();
        //     handleFilterFooter();
        // }
    };

    const formatPrice = () => {
        jQuery(
            ".c7-product__add-to-cart__price span.c7-sr-only + span,.c7-product__add-to-cart__price .c7-price--discounted"
        ).each(function (i, e) {
            let text = jQuery(e).text();
            jQuery(e).text(
                text.replace("$", "").replace(".00", "").replace("Was", "").replace("Now", "")
            );
            jQuery(e).prepend(`<span class="currency">$</span>`)
        });
        jQuery(
            ".c7-product__add-to-cart__price"
        ).css("display", "flex")
    }
    const renderedCollection = () => {
        var collection = ''
        var page = 1;
        var queryString = window.location.search;
        if (window.location.search) {
            queryString = queryString.substring(1);
            var params = {};
            queryString.split('&').forEach(function (pair) {
                var parts = pair.split('=');
                var key = decodeURIComponent(parts[0]);
                var value = decodeURIComponent(parts[1] || '');
                if (key.length) {
                    if (params[key]) {
                        if (Array.isArray(params[key])) {
                            params[key].push(value);
                        } else {
                            params[key] = [params[key], value];
                        }
                    } else {
                        params[key] = value;
                    }
                }
            });
            collection = params.shopSlug
            page = params.currentPage
        } else {
            collection = jQuery(".filter-control ul li").first().find("a").data("collection")
        }
        jQuery(".filter-control ul li a").removeClass("active")
        jQuery(".filter-control ul li a").each(function () {
            if (jQuery(this).data("collection") == collection) {
                jQuery(this).addClass("active")
            }
        })
        jQuery(".filter-results .c7-product-collection__product-list .c7-product").removeClass("show")
        jQuery(".filter-results .c7-product-collection__product-list .c7-product").each(function (index) {
            const dataProduct = jQuery(this).data("product")
            var elementProduct = jQuery(this);
            if (collection == 'all-wines') {
                jQuery(this).addClass("show")
            } else {
                dataProduct.collections.forEach(function (item) {
                    if (item.slug == collection) {
                        elementProduct.addClass("show")
                    }
                })
                // for (let i = 1; i <= 5; i++) {
                //     if (dataProduct.metaData['collection-' + i] && dataProduct.metaData['collection-' + i] == collection) {
                //         jQuery(this).addClass("show")
                //     }
                // }
            }
        })
        var items = jQuery(".filter-results .c7-product-collection__product-list .c7-product.show");
        var numItems = items.length;
        var perPage = 12;
        var totalPage = Math.ceil(numItems / perPage)
        var startIndex = (page - 1) * perPage;
        var endIndex = Math.min(startIndex + perPage - 1, numItems - 1)
        jQuery(".filter-results .c7-product-collection__product-list .c7-product").hide()
        items.each(function (index) {
            if (startIndex <= index && index <= endIndex) {
                jQuery(this).show()
            }
        })
        jQuery(".pagination-container").empty();
        var html = `<div class="pagination text-center">`;
        if (Number(page) > 1) {
            html = html + `<a class="prev" href="?shopSlug=${collection}&currentPage=${(Number(page) - 1)}"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill=
            "none">
               <path d="M4.5 1L10 6.5L4.5 12C4.5 12 5.51501 8.7275 5.5 6.5C5.48547 4.34385 4.5 1 4.5 1Z" fill="#20282B"/>
                   </svg></a>`
        }
        for (let i = 1; i <= totalPage; i++) {
            html = html + `<a class="${page == i ? 'active' : ''}" href="?shopSlug=${collection}&currentPage=${Number(i)}">${i}</a>`;
        }
        if (Number(page) < totalPage) {
            html = html + `<a class="next" href="?shopSlug=${collection}&currentPage=${(Number(page) + 1)}"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill=
            "none">
               <path d="M4.5 1L10 6.5L4.5 12C4.5 12 5.51501 8.7275 5.5 6.5C5.48547 4.34385 4.5 1 4.5 1Z" fill="#20282B"/>
                   </svg></a>`
        }
        html += `</div>`
        jQuery(".pagination-container").append(`` + html)
        handlePagination()
    };
    const registerEventHandlers = () => {
        jQuery(".filter-control ul li a").click(function (e) {
            e.preventDefault()
            const url = jQuery(this).attr("href");
            history.pushState(null, null, url);
            // jQuery(".filter-control ul li a").removeClass("active")
            // jQuery(this).addClass("active")
            renderedCollection()
        })
        handlePagination()
    }
    const handlePagination = () => {
        jQuery(".pagination a").click(function (e) {
            e.preventDefault()
            const url = jQuery(this).attr("href");
            history.pushState(null, null, url);
            jQuery(".pagination a").removeClass("active")
            jQuery(this).addClass("active")
            renderedCollection()
            setTimeout(function () {
                jQuery("html, body").animate(
                    {
                        scrollTop: jQuery(".shop-filter-wrapper").offset().top - 60,
                    },
                    500
                );
            }, 1000)
        })
    }
    const handleFilterFooter = () => {
        jQuery(".footer__menu .filter-collection").click(function (e) {
            e.preventDefault()
            const url = jQuery(this).attr("href");
            history.pushState(null, null, url);
            renderedCollection()
            setTimeout(function () {
                jQuery("html, body").animate(
                    {
                        scrollTop: jQuery(".shop-filter-wrapper").offset().top - 60,
                    },
                    500
                );
            }, 1000)
        })
    }
}
